import { Reveal, MaskLines } from "../components/Reveal";

const NEWS = [
  {
    tag: "New Project Announced",
    date: "December 2026",
    title: "Dhara Kala Movies unveils expanded slate — 12 features and 2 concepts in development",
    body: "The studio announces its full 2026-27 production slate, spanning developed features, active productions, on-the-floor shoots and two future concept films across animation and social drama.",
    editable: true,
  },
  {
    tag: "Production Begins",
    date: "November 2026",
    title: "Principal photography launches for Pilgrimage to the Hidden Lake",
    body: "Cameras roll in Nepal for the pilgrimage-drama, following travellers through high-altitude terrain to a sacred hidden lake.",
    editable: true,
  },
  {
    tag: "Behind-the-Scenes Update",
    date: "November 2026",
    title: "The Mask of Bhairav — festival research diaries",
    body: "The Kathmandu Valley shoot enters its ritual-documentation phase. Behind-the-scenes stills forthcoming.",
    editable: true,
  },
  {
    tag: "International Market Participation",
    date: "October 2026",
    title: "TIFF: The Market 2026 — participation objective",
    body: "Dhara Kala Movies continues to explore international film-market, festival and distribution opportunities for its growing slate of culturally driven projects. TIFF: The Market 2026 is a market-participation objective; no official selection is claimed.",
    editable: true,
  },
  {
    tag: "Trailer Release",
    date: "September 2026",
    title: "Teaser trailer forthcoming — Eternal Flow: The Arrow of Arjun",
    body: "A first teaser is in post-production. Release date to be announced.",
    editable: true,
  },
  {
    tag: "Cultural Research Journey",
    date: "August 2026",
    title: "Research team returns from Halesi Dham and Mustang",
    body: "A four-week location-and-ritual research expedition informs three of the studio's upcoming productions.",
    editable: true,
  },
];

const FESTIVAL_CATEGORIES = [
  { title: "International Film Festivals", body: "Submission and participation plans for select international festivals across Asia, Europe and the Americas." },
  { title: "Film Markets", body: "Market participation objective at TIFF: The Market 2026 and other industry markets." },
  { title: "Project Development Programs", body: "Engagement with international co-development labs and screenwriter programs." },
  { title: "Cultural Screenings", body: "Community and cultural-institution screenings within Nepal, India and diaspora regions." },
  { title: "Press and Media", body: "Press outreach across trade publications and cultural-affairs media." },
  { title: "Distribution Opportunities", body: "Active discussions with domestic and international distribution partners." },
];

export default function News() {
  return (
    <main data-testid="news-page" className="bg-black pt-32 md:pt-40">
      <section className="max-w-[1600px] mx-auto px-6 md:px-10 pb-16">
        <p className="text-[10px] uppercase tracking-overline text-[color:var(--dk-gold)] mb-6">News & Festivals</p>
        <h1 className="font-serif-display font-light text-white text-6xl md:text-8xl lg:text-9xl leading-[0.9] tracking-tighter">
          <MaskLines lines={["Dispatches", "from the set."]} />
        </h1>
      </section>

      {/* News cards */}
      <section className="max-w-[1600px] mx-auto px-6 md:px-10 pb-24">
        <p className="text-[10px] uppercase tracking-overline text-[color:var(--dk-gold)]/70 mb-6 italic">
          Sample news content — editable placeholders
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {NEWS.map((n, i) => (
            <Reveal key={i} delay={i % 3}
              data-testid={`news-card-${i}`}
              className="group border border-white/10 bg-[color:var(--dk-muted)] p-6 md:p-8 hover:border-[color:var(--dk-gold)]/50 transition-colors">
              <div className="flex items-center justify-between mb-5">
                <span className="text-[10px] uppercase tracking-overline text-[color:var(--dk-gold)]">{n.tag}</span>
                <span className="text-[10px] uppercase tracking-overline text-white/50">{n.date}</span>
              </div>
              <h3 className="font-serif-display text-white text-2xl md:text-3xl leading-tight mb-4 group-hover:text-[color:var(--dk-gold)] transition-colors">{n.title}</h3>
              <p className="text-white/60 text-sm leading-relaxed">{n.body}</p>
              {n.editable && (
                <p className="mt-6 text-[9px] uppercase tracking-overline text-white/30 italic">Placeholder — editable</p>
              )}
            </Reveal>
          ))}
        </div>
      </section>

      {/* Festivals & Markets */}
      <section className="border-t border-white/10 bg-[color:var(--dk-muted)]">
        <div className="max-w-[1600px] mx-auto px-6 md:px-10 py-24 md:py-32">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-14">
            <Reveal className="md:col-span-4">
              <p className="text-[10px] uppercase tracking-overline text-[color:var(--dk-gold)]">Festivals & Markets</p>
            </Reveal>
            <Reveal delay={1} className="md:col-span-8">
              <h2 className="font-serif-display font-light text-white text-4xl md:text-6xl leading-[1] tracking-tight">
                Exploring international <span className="italic text-[color:var(--dk-gold)]">opportunities.</span>
              </h2>
              <p className="mt-6 text-white/70 leading-relaxed max-w-3xl">
                Dhara Kala Movies continues to explore international film-market, festival
                and distribution opportunities for its growing slate of culturally driven
                projects.
              </p>
            </Reveal>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {FESTIVAL_CATEGORIES.map((c, i) => (
              <Reveal key={i} delay={i % 3}
                data-testid={`festival-card-${i}`}
                className="border border-white/10 bg-black p-6 md:p-8 hover:border-[color:var(--dk-gold)]/50 transition-colors">
                <span className="text-[10px] uppercase tracking-overline text-[color:var(--dk-gold)]/70 mb-4 block">
                  Category {String(i + 1).padStart(2, "0")}
                </span>
                <h3 className="font-serif-display text-white text-2xl leading-tight mb-3">{c.title}</h3>
                <p className="text-white/60 text-sm leading-relaxed">{c.body}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
